import React, { createContext, useContext } from 'react';
import { useWebChat } from '../components/askEmma/hooks/useWebChat';

const AskEmmaContext = createContext(null);

export const AskEmmaProvider = ({ children }) => {
    const webChatData = useWebChat();

    return (
        <AskEmmaContext.Provider value={webChatData}>
            {children}
        </AskEmmaContext.Provider>
    );
};

export const useAskEmma = () => {
    const context = useContext(AskEmmaContext);
    if (!context) {
        throw new Error('useAskEmma must be used within an AskEmmaProvider');
    }
    return context;
};
